<template>
    <div class="edit-plan">
        <el-form
        :model="form"
        :rules="rules"
        label-position="top"
        ref="addContentForm"
        :disabled="loading"
        v-loading="loading">
        <div style="display: flex; align-items: center;">
          <el-form-item prop="medium_id" :label="$t('media')">
            <el-select
            v-model="form.medium_id"
            :placeholder="$t('media')"
            style="margin-inline-end: 10px;">
              <el-option
                v-for="m in media.list"
                :key="m.name"
                :label="m.label"
                :value="m.id.numberStr"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item prop="source" :label="$t('source')" style="flex: 1;">
              <el-select
                  v-model="form.source"
                  filterable
                  remote
                  multiple
                  :multiple-limit="1"
                  reserve-keyword
                  placeholder=""
                  :loading="sourceLoading"
                  popper-class="source-selector"
                  class="full-width source-selector"
                  :remote-method="remoteSourceSearch">
                  <el-option
                  v-for="s in sources"
                  :key="s.id.numberStr"
                  :label="`${s.name} (${s.platform.label})`"
                  :value="s.id.numberStr">
                      <div class="avatar pull-right source-item"
                      :style="`background-image:url(${s.image})`">
                      <div
                          class="medium"
                          :style="`background-image:url(${s.platform.image})`" />
                      </div>
                      <div class="info pull-right source mr-15">
                      <span>
                          {{ s.name }}
                      </span>
                      <span class="text-right">
                          {{ s.username }}
                      </span>
                      </div>
                  </el-option>
              </el-select>
          </el-form-item>
        </div>
        <el-form-item prop="content" :label="$t('content')">
            <el-input v-model="form.content" />
        </el-form-item>
        <el-form-item prop="link" :label="$t('link')">
            <el-input v-model="form.link" />
        </el-form-item>
        <el-form-item prop="publish_ts" :label="$t('publish_date')">
            <el-input id="publish_ts" v-model="jDatetimePublish_ts" readonly/>
            <persian-datetime-picker
                  type="datetime"
                  v-model="form.publish_ts"
                  placeholder="تاریخ انتشار"
                  color="#5E35B1"
                  :format="isoFormat"
                  :auto-submit="true"
                  :max="today"
                  element="publish_ts" />
        </el-form-item>
        <el-form-item prop="upload_file" :label="$t('multimedia')">
          <!-- <el-input id="add-content-file-upload" v-model="form.file" type="file" accept="video/*,image/*"/> -->
          <el-upload
            ref="file"
            :auto-upload="false"
            action="#"
            :show-file-list="true"
            :file-list="form.file"
            :limit="5"
            :on-change="(file, fileList) => checkSize(file, fileList)">
            <el-button size="small" type="primary">{{$t('add_media')}}</el-button>
          </el-upload>
        </el-form-item>
        <div class="line"></div>
        <el-form-item>
            <el-button
            type="primary" :loading="loading" @click="submitAddContent">
            {{ $t('submit') }}
            </el-button>
        </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment-jalaali'
import PersianDatetimePicker from 'vue-persian-datetime-picker'
import { debounce } from '@/utils/debounce'
export default {
  components: {
    PersianDatetimePicker
  },
  data () {
    var urlValidation = (rule, value, callback) => {
      /* eslint-disable */
      let urlRegex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig
      if (!urlRegex.test(value)) {
        callback(new Error(`${this.$i18n.t('field_required')}`))
      } else {
        callback()
      }
    }
    return {
      isoFormat: 'YYYY-M-DTHH:mm:ss',
      jalaliFormat: 'HH:mm jYYYY/jM/jD',
      form: {
        source: '',
        content: '',
        link: '',
        publish_ts: '',
        file: [],
        medium_id: ''
      },
      rules: {
        source: [{
          required: true,
          message: this.$i18n.t('field_required')
        }],
        content: [{
          required: true,
          message: this.$i18n.t('field_required')
        }],
        link: [{
          validator: urlValidation,
          trigger: 'blur'
        }],
        publish_ts: [{
          required: true,
          message: this.$i18n.t('field_required')
        }]
      },
      sources: [],
      loading: false,
      sourceLoading: false,
      typeError: '',
      sizeError: '',
      files: []
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath',
      'media'
    ]),
    jDatetimePublish_ts () {
      if (this.form.publish_ts) {
        return moment(this.form.publish_ts, this.isoFormat)
          .format(this.jalaliFormat)
      }
      return ''
    },
    today () {
      let date = new Date()
      let isoDateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString()
      return isoDateTime
    }
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    async fetchMedia () {
      this.handleRequest({
        name: `media`,
        action: 'getAll',
        mutation: 'SET_MEDIA'
      })
    },
    // Debounced search function for better performance
    debouncedSourceSearch: debounce(function(query) {
      this.sourceLoading = true
      if (query.length === 0) {
        return
      }
      const params = { query }
      if (this.form.medium_id) {
        params.medium_id = this.form.medium_id
      }
      this.handleRequest({
        name: `${this.domainsPath}/sources`,
        action: 'getAll',
        data: { query: params }
      }).then((res) => {
        this.sources = res.list
        this.sourceLoading = false
      })
    }, 500), // 500ms debounce delay
    remoteSourceSearch (query) {
      this.debouncedSourceSearch(query)
    },
    handleAddContentOnSuccess () {
      const message = this.$i18n.t('is_successful', {
        operation: this.$i18n.t('add_content')
      })
      this.$message({
        message,
        type: 'success'
      })
    },
    submitAddContent () {
      this.$refs['addContentForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          // let data = {
          //   source_id: this.form.source[0],
          //   display_text: this.form.content,
          //   link: this.form.link,
          //   publish_ts: this.form.publish_ts,
          //   file: this.form.file
          // }
          const form = new FormData()
          form.append('source_id', this.form.source[0])
          form.append('display_text', this.form.content)
          form.append('link', this.form.link)
          form.append('publish_ts', this.form.publish_ts)
          this.form.file.map(element => {
            form.append('file', element.raw)
          })
          this.handleRequest({
            name: `${this.domainsPath}/contents`,
            action: 'create',
            data: form
          }).then(this.handleAddContentOnSuccess)
            .finally(() => {
              this.loading = false
              this.form.file = []
              this.$refs['addContentForm'].resetFields()
              this.$refs['file'].clearFiles()
            })
        } else {
          return false
        }
      })
    },
    checkSize (file, fileList) {
      const isValidType =
      file.raw.type === 'image/png' ||
      file.raw.type === 'image/jpg' ||
      file.raw.type === 'image/jpeg' ||
      file.raw.type === 'image/svg+xml' ||
      file.raw.type === 'video/mp4'

      const isLt1M = file.size / 1024 / 1024 < 1

      if (!isValidType) {
        this.typeError = this.$i18n.t('unsupported_type')
      }
      if (!isLt1M) {
        this.sizeError = this.$i18n.t('maximum_size_1mb')
      }

      if (isValidType && isLt1M) {
        this.form.file = fileList
      } else {
        if (this.typeError) {
          this.$message.error(this.$i18n.t('unsupported_type'))
        } else if (this.sizeError) {
          this.$message.error(this.$i18n.t('maximum_size_1mb'))
        }
        fileList.pop()
      }
    }
  },
  created () {
    this.fetchMedia()
  }
}
</script>

<style lang="scss" scoped>
.source-selector {
    &.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
      padding-inline-start: 20px;
      &::after {
        right: 5px;
      }

    }

    .el-select-dropdown__item {
        height: 60px;
        display: flex;
        align-items: center;
        .source-item {
            display: flex;
            align-items: center;
            direction: rtl;
                height: 4.5rem !important;
            &.avatar {
                width: 2.5rem !important;
                height: 2.5rem !important;
                .medium {
                    right: -2px;
                }
            }
        }
        .info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            margin-inline-start: 10px;
            span {
                line-height: 1.25rem;
            }
        }
    }

}
</style>
